module.exports = {
  __depends__: [
    require(155),
    require(232),
    require(122)
  ],
  __init__: [
    'labelEditingProvider',
    'labelEditingPreview'
  ],
  labelEditingProvider: [ 'type', require(29) ],
  labelEditingPreview: [ 'type', require(28) ]
};
